import { configureStore } from '@reduxjs/toolkit'
import { createBrandFormSlice } from './createBrandFormState'
import { userSlice } from './userState'




export const store = configureStore({
    reducer: {
      brandForm: createBrandFormSlice.reducer,
      user: userSlice.reducer,
      }
})